import { render, staticRenderFns } from "./FixTx.vue?vue&type=template&id=6ddacb9f&"
import script from "./FixTx.vue?vue&type=script&lang=js&"
export * from "./FixTx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports